 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		2: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"24c98fde5dd4bdafca8066e863287a946893d231","4":"component---src-pages-404-js","5":"component---src-pages-about-us-js","6":"component---src-pages-advertising-specifications-js","7":"component---src-pages-arts-programs-js","8":"component---src-pages-digital-publications-js","9":"component---src-pages-index-js","10":"component---src-pages-professional-journals-js","11":"component---src-pages-publications-ballet-west-js","12":"component---src-pages-publications-broadway-at-the-eccles-js","13":"component---src-pages-publications-broadway-in-boise-js","14":"component---src-pages-publications-deer-valley-music-festival-js","15":"component---src-pages-publications-grand-theatre-js","16":"component---src-pages-publications-kurt-bestor-js","17":"component---src-pages-publications-mobile-digital-playbills-js","18":"component---src-pages-publications-odyssey-dance-theatre-js","19":"component---src-pages-publications-onstage-ogden-js","20":"component---src-pages-publications-outdoor-sports-guide-js","21":"component---src-pages-publications-pioneer-theatre-company-js","22":"component---src-pages-publications-salt-lake-acting-company-js","23":"component---src-pages-publications-salt-lake-realtor-js","24":"component---src-pages-publications-tuacahn-amphitheatre-js","25":"component---src-pages-publications-university-utah-basketball-js","26":"component---src-pages-publications-university-utah-football-js","27":"component---src-pages-publications-university-utah-gymnastics-js","28":"component---src-pages-publications-utah-arts-festival-js","29":"component---src-pages-publications-utah-dental-association-js","30":"component---src-pages-publications-utah-festival-opera-js","31":"component---src-pages-publications-utah-opera-js","32":"component---src-pages-publications-utah-physician-js","33":"component---src-pages-publications-utah-shakespeare-festival-js","34":"component---src-pages-publications-utah-symphony-js","35":"component---src-pages-publications-utahpresents-js","36":"component---src-pages-university-sports-programs-js","37":"component---src-pages-upcoming-publications-js"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"3725ca640be6100b5bd4","4":"dd04367d28d79e925777","5":"c21884a36346bb7760bb","6":"c7e8e34c40d515c4c87a","7":"771d67bba32584ff5a08","8":"8dbac12403b4ea16b4d8","9":"2e2c6401bc66004efda4","10":"e4a9287e773524ba8f31","11":"387761be2e84caeb2847","12":"07419ed903773ae78ce3","13":"21bbf57434494ff1112e","14":"dc064a74ed9cf8606a1c","15":"6406beadf4f3c16a1c13","16":"ff1edfc8d9ee15cb3910","17":"9f971b7fb7f92e533254","18":"ec9d6794275b5ee84111","19":"a403e2eb9e2c58b047e0","20":"9f4be8ae406dea5666fc","21":"6d61f9f33a5219cbf64b","22":"46c0aeebf5365b466d33","23":"e56121f180d95fc0bdec","24":"42ebc5403ed0ecf293e0","25":"bea79eb687f1d17b58a8","26":"be0a41a45a31fd366122","27":"8b3770874078ef765839","28":"354c979876f85792d0ee","29":"7bd275c6829385a2863f","30":"253c6840f21ee9d9fb13","31":"ea12841c5c770baf23d5","32":"ffb9a1c5efec229d846a","33":"735f915ed99ffe6311fe","34":"d49e03f7c9e4a7d5c419","35":"400c0b65601f175f761f","36":"7b36b06e6a232d015c27","37":"e0dff51925c3da3297fc","40":"74bbaf113da32ecda75a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"24c98fde5dd4bdafca8066e863287a946893d231","4":"component---src-pages-404-js","5":"component---src-pages-about-us-js","6":"component---src-pages-advertising-specifications-js","7":"component---src-pages-arts-programs-js","8":"component---src-pages-digital-publications-js","9":"component---src-pages-index-js","10":"component---src-pages-professional-journals-js","11":"component---src-pages-publications-ballet-west-js","12":"component---src-pages-publications-broadway-at-the-eccles-js","13":"component---src-pages-publications-broadway-in-boise-js","14":"component---src-pages-publications-deer-valley-music-festival-js","15":"component---src-pages-publications-grand-theatre-js","16":"component---src-pages-publications-kurt-bestor-js","17":"component---src-pages-publications-mobile-digital-playbills-js","18":"component---src-pages-publications-odyssey-dance-theatre-js","19":"component---src-pages-publications-onstage-ogden-js","20":"component---src-pages-publications-outdoor-sports-guide-js","21":"component---src-pages-publications-pioneer-theatre-company-js","22":"component---src-pages-publications-salt-lake-acting-company-js","23":"component---src-pages-publications-salt-lake-realtor-js","24":"component---src-pages-publications-tuacahn-amphitheatre-js","25":"component---src-pages-publications-university-utah-basketball-js","26":"component---src-pages-publications-university-utah-football-js","27":"component---src-pages-publications-university-utah-gymnastics-js","28":"component---src-pages-publications-utah-arts-festival-js","29":"component---src-pages-publications-utah-dental-association-js","30":"component---src-pages-publications-utah-festival-opera-js","31":"component---src-pages-publications-utah-opera-js","32":"component---src-pages-publications-utah-physician-js","33":"component---src-pages-publications-utah-shakespeare-festival-js","34":"component---src-pages-publications-utah-symphony-js","35":"component---src-pages-publications-utahpresents-js","36":"component---src-pages-university-sports-programs-js","37":"component---src-pages-upcoming-publications-js"}[chunkId]||chunkId) + "." + {"0":"5234fbc81ba93862f60d","1":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
